var en = {
	"common": {
		"viewmore": "VIEWMORE",
		"shopdetail": "shop",
		"account": "account",
		"allgoods": "goods",
		"newarrivals": "New arrivals",
		"hot": "Hot",
		"sale": "Sale",
		"oldprice": "oldprice",
		"nowprice": "nowprice",
		"sellcount": "sellcount",
		"coupan": "coupan",
		"buy": "buy",
		"size": "Size",
		"rest": "Rest",
		"coupantext": "no coupantext now",

	}
}

export default en